


















import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import Vue from 'vue';

export interface UiDatePickerDate {
  start: Date;
  end: Date;
  timezone: string;
}

@Component
export default class UiDatePicker extends Vue {
  @Prop()
  value: string;

  @Prop()
  columns: number;

  @Prop({default: 'range'})
  mode: string;

  @Prop({default: null})
  minDate: string;

  @Prop({default: null})
  maxDate: string;

  adjustPageRange() {
    const datePicker = this.$refs.datePicker as any;
    datePicker.adjustPageRange();
  }

  created () {
    this.bus.$on('resetDateRange', () => {
      //@ts-ignore
      if (this.$refs?.datePicker?.dragValue) {
        //@ts-ignore
        this.$refs.datePicker.dragValue = null
      }
    });
  }
}
